import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useDropdownContext } from './DropdownContext';

type DropdownToggleProps = {
  className?: string;
  onSplitButtonClick?: () => void;
};

export const DropdownToggle = ({
  children,
  className,
  onSplitButtonClick,
}: PropsWithChildren<DropdownToggleProps>) => {
  const { size, split, color, purpose } = useDropdownContext();

  const toggleClassName = clsx(
    className,
    `btn-${size}`,
    purpose === 'primary' ? `btn-${color}` : `btn-${purpose}-${color}`,
  );

  const variant = purpose === 'primary' ? '' : purpose;
  return split ? (
    <>
      <Button variant={variant} className={toggleClassName} onClick={onSplitButtonClick}>
        {children}
      </Button>
      <Dropdown.Toggle variant={variant} split className={toggleClassName} />
    </>
  ) : (
    <Dropdown.Toggle variant={variant} className={toggleClassName}>
      {children}
    </Dropdown.Toggle>
  );
};
